import { GripHorizontal, ChevronDown } from 'lucide-react'
import { useRoutingSettingsQuery } from 'v2/pages/settings/queries'
import { CountdownSlider } from './countdown-slider'
import { useCallContext } from './call-context'

interface CallHeaderProps {
  isMinimized: boolean
  setIsMinimized: (value: boolean) => void
  dragAttributes: Record<string, unknown>
  dragListeners: Record<string, unknown>
}

export const CallHeader = ({
  isMinimized,
  setIsMinimized,
  dragAttributes,
  dragListeners,
}: CallHeaderProps) => {
  const { isIncomingCallRinging } = useCallContext()
  const { data: routingSettings } = useRoutingSettingsQuery()
  const timeoutInMs = (routingSettings?.reservation_timeout?.call ?? 0) * 1000

  return (
    <div className="flex flex-col -mx-4">
      {isIncomingCallRinging && <CountdownSlider timeoutInMs={timeoutInMs} />}
      <div className="flex items-center justify-between relative text-tertiary">
        <div
          {...dragAttributes}
          {...dragListeners}
          className="cursor-move flex-1 items-center flex justify-center"
        >
          <GripHorizontal className="h-4 w-4" />
        </div>
        <ChevronDown
          className="h-4 w-4 absolute right-2 cursor-pointer"
          onClick={(e) => {
            e.stopPropagation()
            setIsMinimized(!isMinimized)
          }}
        />
      </div>
    </div>
  )
}
